"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    documentUploads: {
        path: "/files",
    },
    documentUploadDetail: {
        path: "/files/:id",
    },
    documentUploadFile: {
        path: "/view-file/:id",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9jdW1lbnRVcGxvYWRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy9kb2N1bWVudFVwbG9hZHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxlQUFlLEVBQUU7UUFDZixJQUFJLEVBQUUsUUFBUTtLQUNmO0lBQ0Qsb0JBQW9CLEVBQUU7UUFDcEIsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRCxrQkFBa0IsRUFBRTtRQUNsQixJQUFJLEVBQUUsZ0JBQWdCO0tBQ3ZCO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBkb2N1bWVudFVwbG9hZHM6IHtcbiAgICBwYXRoOiBcIi9maWxlc1wiLFxuICB9LFxuICBkb2N1bWVudFVwbG9hZERldGFpbDoge1xuICAgIHBhdGg6IFwiL2ZpbGVzLzppZFwiLFxuICB9LFxuICBkb2N1bWVudFVwbG9hZEZpbGU6IHtcbiAgICBwYXRoOiBcIi92aWV3LWZpbGUvOmlkXCIsXG4gIH0sXG59KTtcbiJdfQ==